/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, Language } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class I18NText<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Returns every language that has at least one maintained/uploaded language file, in enum declaration order; used by the profile language dropdown and the anonymous bootstrap language resolution
   *
   * @tags I18n Text
   * @name GetAvailableLanguages
   * @summary Get available languages
   * @request GET:/api/i18n/languages
   * @secure
   */
  getAvailableLanguages = (params: RequestParams = {}) =>
    this.request<Language[], ErrorResponse>({
      path: `/api/i18n/languages`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Returns the runtime UI text bundle (boxhub.ui.* keys, prefix stripped) for the given language; no German fallback for a not-yet-loaded language
   *
   * @tags I18n Text
   * @name GetTexts
   * @summary Get UI text bundle
   * @request GET:/api/i18n/texts/{language}
   * @secure
   */
  getTexts = (language: Language, params: RequestParams = {}) =>
    this.request<Record<string, string>, ErrorResponse>({
      path: `/api/i18n/texts/${language}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
